import { Injectable } from '@angular/core';
import { PreProposalRequestItemApi } from 'src/app/core/http/entidades/PreProposalRequestItemApi';

@Injectable({
  providedIn: 'root'
})
export class PrepoposalrequestitemService {

  constructor(private api: PreProposalRequestItemApi) {
    this.api.baseName = 'PreProposalRequestItem';
  }
  /** Salvar */
  save(entity: any): any {
    return new Promise((resolve, reject) => {
      this.api.post(entity)
        .then((data: any) => resolve(data))
        .catch(() => {
          reject();
        });
    });
  }
}
